import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import athenaOwl from "../assets/athena_owl.svg";

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex", alignItems: "center", justifyContent: "center",
    background: "var(--bg-page)",
    padding: 24,
  },
  card: {
    width: 360,
    background: "var(--bg-card)",
    borderRadius: 16,
    boxShadow: "var(--shadow-lg)",
    padding: 32,
    border: "1px solid var(--border-hairline)",
  },
  brand: { display: "flex", flexDirection: "column", alignItems: "center", marginBottom: 24 },
  title: { fontSize: 22, fontWeight: 600, color: "var(--text-primary)", marginTop: 16, textAlign: "center" },
  sub:   { fontSize: 13, color: "var(--text-muted)", marginTop: 4, textAlign: "center" },
  rule:  { width: 64, height: 2, background: "var(--accent-mint)", margin: "20px 0 0", borderRadius: 2 },
  err:   { color: "var(--color-danger)", fontSize: 12, marginTop: 6 },
  full:  { width: "100%" },
  hint:  { textAlign: "center", fontSize: 12, color: "var(--text-hint)", marginTop: 16 },
};

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setErr(null); setBusy(true);
    try {
      const u = await login(identifier.trim(), password);
      const dest = ({
        admin: "/dashboard",
        reparto: "/dashboard",
        insumos: "/insumos/mine",
        reparto_insumos: "/reparto-insumos",
        revisor_fallos: "/fallos",
        abogado: "/abogado",
      })[u.role] || "/dashboard";
      nav(dest, { replace: true });
    } catch (e) {
      setErr(e?.response?.data?.error || "No se pudo iniciar sesión.");
    } finally { setBusy(false); }
  }

  return (
    <div style={styles.page}>
      <form style={styles.card} onSubmit={submit}>
        <div style={styles.brand}>
          <img src={athenaOwl} alt="Athena" className="athena-owl" width={96} height={111} style={{ display: "block", margin: "0 auto 12px" }} />
          <div style={styles.title}>Athena</div>
          <div style={styles.sub}>Plataforma de Administración y Gestión de Procesos Judiciales</div>
          <div style={styles.rule} />
        </div>

        <div className="col" style={{ gap: 16 }}>
          <div>
            <label>Usuario o correo</label>
            <input
              type="text" autoFocus required
              value={identifier} onChange={(e) => setIdentifier(e.target.value)}
              placeholder="admin o su.correo@edys-sas.com"
              autoComplete="username"
            />
          </div>
          <div>
            <label>Contraseña</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <button type="submit" disabled={busy} style={styles.full}>
            {busy ? "Ingresando…" : "Ingresar"}
          </button>
          {err && <div style={styles.err}>{err}</div>}
        </div>

        <div style={styles.hint}>Use su correo institucional @edys-sas.com</div>
      </form>
    </div>
  );
}
